import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-section-header',
  templateUrl: './section-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionHeaderComponent implements AfterViewChecked {
  @Input() border = true;
  @ViewChild('controls') controlsSection?: ElementRef<HTMLDivElement>;
  isControlsSectionShown = true;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  ngAfterViewChecked(): void {
    this.isControlsSectionShown = !!this.controlsSection?.nativeElement?.children.length;
    this.cdr.detectChanges();
  }
}
